import React from "react";
import { ChangeEvent } from "react";
import { Link } from "react-router-dom";
import { RouteComponentPropsHistory } from "../../types";

import { DateTime } from "luxon";

import { apiPost } from "../../Api";
import { formatDateLocal, formatName } from "../../Utilities";
import withTitle from "../withTitle";

import "../../schedule.css";
import "../viewer.css";
import DelayInput from "../DelayInput";

interface IHealthFairSearchViewState {
    searchText: string;
    searchResults?: { [date: string]: any[] };
    isLoading: boolean;
    error?: string;
}

class HealthFairSearchView extends React.Component<RouteComponentPropsHistory<any, any>, IHealthFairSearchViewState> {
    constructor(props: Readonly<RouteComponentPropsHistory<any, any>>) {
        super(props);

        this.state = {
            isLoading: false,
            searchText: (props.location.state && props.location.state.searchText) || ""
        };

        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.searchFairs = this.searchFairs.bind(this);
    }

    public componentDidMount() {
        this.searchFairs();
    }

    public render() {
        let results;

        if (this.state.isLoading) {
            results = <div className="lds-dual-ring spinner-center" />;
        }
        else if (this.state.error) {
            results = <span className="error-text">{this.state.error}</span>;
        }
        else if (this.state.searchResults && Object.keys(this.state.searchResults).length === 0) {
            results = <span>No health fairs found</span>;
        }
        else if (this.state.searchResults) {
            results = (
                <section className="info-block">
                    <header>
                        <h3>Results</h3>
                    </header>
                    {
                        Object.keys(this.state.searchResults).map(k => (
                            <section key={k} className="schedule-section">
                                <h3>{formatDateLocal(k)}</h3>
                                <ul>
                                    {
                                        this.state.searchResults![k].map(r => (
                                            <li key={r.scheduledDate + r.name}>
                                                <Link to={`/fairs/${r.id}`}>
                                                    <span>{r.name}</span>
                                                    <span className="small-text">{`${r.address.city}, ${r.address.state}`}</span>
                                                    <span className="small-text member-list">{r.members.map((m: any) => formatName(m.name)).join(", ")}</span>
                                                </Link>
                                            </li>
                                        ))
                                    }
                                </ul>
                            </section>
                        ))
                    }
                </section>
            );
        }

        return (
            <div className="viewer-root">
                <div className="filter-control-box">
                    <DelayInput type="search" timeout={500} placeholder="Search..." className="fill-space" autoFocus={true} value={this.state.searchText} onChangeDelayed={this.handleSearchChange} />
                </div>
                {results}
            </div>
        );
    }

    private handleSearchChange(e: ChangeEvent<HTMLInputElement>) {
        this.setState({
            searchText: e.currentTarget.value
        }, () => this.searchFairs());
    }

    private async searchFairs() {
        if (!this.state.searchText) {
            this.setState({
                searchResults: {}
            });
            return;
        }

        this.saveSearchState();

        this.setState({
            isLoading: true,
        })

        try {
            const results = await apiPost<any[]>("fairs/search", { query: this.state.searchText });

            const groups: { [time: string]: any[] } = {};
            results.forEach(r => {
                const date = DateTime.fromISO(r.scheduledDate);
                const dateString = date.toISODate();
                if (!groups[dateString]) {
                    groups[dateString] = [];
                }

                groups[dateString].push(r);
            });

            this.setState({
                error: undefined,
                isLoading: false,
                searchResults: groups
            });

            /*
        this.setState({
            searchResults: [
                { "id": "806701157842944", "scheduledDate": "2018-09-05T11:30:00-04:00", "name": "Origami Textiles", "address": { "street": "592 Twisty Rd", "city": "Creaseville", "state": "GA", "zip": "34028" }, "estimatedHeadCount": 50, "members": [{ "id": "693791518359552", "name": { "first": "Roberta", "last": "Adan" } }, { "id": "534615747461120", "name": { "first": "Betty", "last": "Rollins" } }] },
                { "id": "847066565443584", "scheduledDate": "2018-09-06T11:00:00-04:00", "name": "Paradise Fairgrounds", "address": { "street": "555 Best Street", "city": "Placeville", "state": "GA", "zip": "09175" }, "estimatedHeadCount": 30, "members": [{ "id": "693791518359552", "name": { "first": "Roberta", "last": "Adan" } }] },
                { "id": "846936253399040", "scheduledDate": "2018-09-13T10:30:00-04:00", "name": "Someplace Regional Medical Center", "address": { "street": "1234 Best Street", "city": "Someplace", "state": "GA", "zip": "12345" }, "estimatedHeadCount": 40, "members": [{ "id": "534609901125632", "name": { "first": "Susan", "last": "Sanchez" } }, { "id": "534624713834496", "name": { "first": "Daniella", "last": "Jacobs", "title": "Dr" } }] }
            ]
            });
            */
        } catch (e) {
            this.setState({
                error: e.message,
                isLoading: false
            });
        }
    }

    private saveSearchState() {
        const currentLocation = this.props.location;
        currentLocation.state = {
            searchText: this.state.searchText,
        };
        this.props.history.replace(currentLocation);
    }
}

export default withTitle("Search Health Fairs", HealthFairSearchView);
